import UserGroupSelectComponent from "@via/components/select/user-group-select-component";
import SharedWithProjects from "@via/pages/account/profile/run-environments/shared-with-projects.tsx";
import { type JSX } from "react";

export const accessCardSummary = (params: {
  writeGroupCount: number;
  isEdit: boolean;
}): string => {
  if (!params.isEdit) return "Saved on create";
  return params.writeGroupCount === 1
    ? "1 write group"
    : `${params.writeGroupCount} write groups`;
};

export function AccessCard({
  runEnvironmentId,
  selectedWriteGroupIds,
  onWriteGroupsChange,
}: {
  runEnvironmentId?: number;
  selectedWriteGroupIds: number[];
  onWriteGroupsChange: (ids: number[]) => void;
}): JSX.Element {
  return (
    <>
      <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          Group Permission to Write
        </label>
        <p className="text-xs text-gray-500">
          Members of these groups can edit and delete this run environment.
        </p>
        <div className="mt-2">
          <UserGroupSelectComponent
            name="writeGroupId"
            isMulti={true}
            {...(selectedWriteGroupIds.length
              ? { missingId: selectedWriteGroupIds }
              : {})}
            onChange={(value: unknown) => {
              const options = (Array.isArray(value) ? value : []) as {
                value: number;
              }[];
              onWriteGroupsChange(options.map(option => Number(option.value)));
            }}
          />
        </div>
      </div>

      {runEnvironmentId ? (
        <div data-testid="shared-with-projects">
          <SharedWithProjects profileClusterId={runEnvironmentId} />
        </div>
      ) : null}
    </>
  );
}
